import { FC } from 'react';
import expertiseIcon from 'images/expertise-icon.svg';

interface ExpertiseIconProps {
  width: string;
  height: string;
}

const ExpertiseIcon: FC<ExpertiseIconProps> = (props): JSX.Element => {
  const { width, height } = props;
  return (
    <img
      width={width}
      height={height}
      src={expertiseIcon}
      alt="expertise-icon"
    />
  );
};
export default ExpertiseIcon;
